import React, { useEffect } from 'react';
import { useFormItemContext } from '../FormItemContext';

/**
 * Permette di aggiungere un testo aggiuntivo al label del campo, disponibile
 * soltanto per screen reader.
 * Utilizzato per fornire informazioni aggiuntive al campo, ad esempio
 * nelle SelectInput per indicare le opzioni selezionate.
 */
export function useFormItemScreenReaderLabelAddition(content: React.ReactNode) {
  const { setLabelAddition } = useFormItemContext();
  useEffect(() => {
    if (!content) {
      setLabelAddition?.(undefined);
      return;
    }

    setLabelAddition?.(<span className="sr-only">: {content}</span>);
  }, [content, setLabelAddition]);
}
